var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /opt/wh/whtree/~/core-js/modules/_html.js
// module id = 636
// module chunks = 0